export { default } from './DeviceDataAttribution';
export type { DeviceDataAttributionProps } from './DeviceDataAttribution';
